module.exports = __webpack_public_path__ + "images/user.36fc2ca9764c886cb26cdc17990b824e.png";